module.exports = __webpack_public_path__ + "static/img/bejing.7528cf4.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/bejing.png
// module id = GCGx
// module chunks = 1